export default __webpack_public_path__ + "static/media/private.81477e2c.svg";